var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYouair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-186 -452)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 25,
    height: 25,
    transform: "translate(186 452)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24875",
    "data-name": "Group 24875",
    transform: "translate(-269.139 157.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37000",
    "data-name": "Path 37000",
    d: "M476.135,295.7c.1,1.312.778,2.54,2.585,3.866s3.28,2.2,4.5,2.952,4.439,2.547,5.11,3.02,3.02,1.738,3.112,3.294c.579-.839.976-1.709-.046-2.73a30.523,30.523,0,0,0-5.217-3.523c-1.769-1.007-6.192-3.523-7.23-4.255S476.28,296.443,476.135,295.7Z",
    transform: "translate(-15.996)",
    fill: "#09f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37001",
    "data-name": "Path 37001",
    d: "M491.621,309.965a37.953,37.953,0,0,0-5.323-3.989c-2.082-1.266-5.563-3.362-6.51-4.049s-2.439-1.762-2.563-2.452c.076,1.211.686,2.351,2.337,3.6s3.058,2.023,4.174,2.727,3.99,2.462,4.612,2.893a20.769,20.769,0,0,1,2.481,1.946,8.587,8.587,0,0,0,.792-.676Z",
    transform: "translate(-16.294 -1.031)",
    fill: "#03c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37002",
    "data-name": "Path 37002",
    d: "M490.5,312.057a41.442,41.442,0,0,0-4.125-2.9c-1.919-1.207-5.128-3.206-6-3.858s-2.243-1.673-2.349-2.317c.053,1.127.606,2.2,2.123,3.377s2.758,1.969,3.786,2.639,3.736,2.3,4.309,2.713c.465.334.886.654,1.24.936Z",
    transform: "translate(-16.513 -1.989)",
    fill: "#009"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37003",
    "data-name": "Path 37003",
    d: "M493.5,311.637a4.144,4.144,0,0,1-1.43,3.2,16.528,16.528,0,0,1-4.347,2.254c-.995.377-3.1,1.109-3.935,1.5a7.643,7.643,0,0,0-2.231,1.373,6.776,6.776,0,0,1,3.065-2.437c1-.5,2.918-1.327,4-1.83a18.381,18.381,0,0,0,3.776-2.071,2.849,2.849,0,0,0,1.1-1.989Z",
    transform: "translate(-17.478 -4.351)",
    fill: "#09f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37004",
    "data-name": "Path 37004",
    d: "M492.13,316.027c-.355,1.224-.606,1.876-2.46,2.849a42.18,42.18,0,0,1-5.857,2.071c-1.109.389-2.654.824-3.18,1.7a1.164,1.164,0,0,0-.035,1.224c-.526-.6-.583-.984-.5-1.339s.4-.881,1.442-1.487a27.779,27.779,0,0,1,4.335-1.853c1.556-.538,3.329-1.144,4.072-1.5S491.935,316.771,492.13,316.027Z",
    transform: "translate(-17.069 -5.549)",
    fill: "#03c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37005",
    "data-name": "Path 37005",
    d: "M491.806,318.812a6.947,6.947,0,0,1-3.123,2.036,27.282,27.282,0,0,1-2.86.663,11.62,11.62,0,0,0-2.917.8,4.579,4.579,0,0,0-1.384.892,8.3,8.3,0,0,1,3.066-.79,29.576,29.576,0,0,0,4.187-.606A3.952,3.952,0,0,0,491.806,318.812Z",
    transform: "translate(-17.467 -6.31)",
    fill: "#009"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouair);
export default __webpack_public_path__ + "static/media/youair.8432b3e71c2984155da6c8a3bfa80bc5.svg";
export { ForwardRef as ReactComponent };